import React from 'react';

export const SuccessAlert = () => (
    <>
        <div className="page__title">{window.VULOG_TRANSLATE('Well done!')}</div>
        <div className="alert alert-success" role="alert">
            <p>{window.VULOG_TRANSLATE('adyenSuccess')}</p>
        </div>
    </>
);

export const InfoAlert = () => (
    <>
        <div className="page__title">{window.VULOG_TRANSLATE('Almost done!')}</div>
        <div className="alert alert-info" role="alert">
            <p>{window.VULOG_TRANSLATE('adyenPending')}</p>
        </div>
    </>
);

export const ErrorAlert = () => (
    <>
        <div className="page__title">{window.VULOG_TRANSLATE('Ooops!')}</div>
        <div className="alert alert-danger" role="alert">
            <p>{window.VULOG_TRANSLATE('adyenError')}</p>
        </div>
    </>
);
